<script context="module">
import { writable } from "svelte/store";
import { schedule$ } from './store';

const notifications = writable([])

let id = 0;
export function createNotification(title, target, hideAfter = 3000, external = false) {
  const index = id++;
  notifications.update(nots => [...nots, {id: index, title, target, external, hideTime: Date.now() + hideAfter}])

  setTimeout(() => {
    notifications.update(n => n.filter(n => n.id !== index))
  }, hideAfter)
}

///////
/// Notification service
const NotifyBefore = 10 * 60_000;
const NotifyStartingNow = 2 * 60_000;

// In-memory already notified cache
const notified = {}

schedule$.subscribe(events => {
  const now = Date.now();
  const startingSoon = []
  const startingNow = []
  
  events.forEach(e => {
    const ts = e.startTime.getTime()
    if (now >= ts - NotifyBefore && now < ts) startingSoon.push(e)
    else if (now >= ts && now < ts + NotifyStartingNow) startingNow.push(e)
  })

  startingSoon.forEach(e => {
    if (notified[e.id + "soon"]) return;
    notified[e.id + "soon"] = 1;
    const external = e.liveStream.type === 'zoom';
    const link = external ? e.liveStream.url : 'show/' + e.id;
    createNotification(e.title + " starting soon!", link, 15_000, external);
  })

  startingNow.forEach(e => {
    if (notified[e.id + "now"]) return;
    notified[e.id + "now"] = 1;
    const external = e.liveStream.type === 'zoom';
    const link = external ? e.liveStream.url : 'show/' + e.id;
    createNotification(e.title + " is live!", link, 15_000, external);
  })
});
</script>

<script>
import { fade } from 'svelte/transition';
import { useNavigate } from "svelte-navigator";

const navigate = useNavigate();

const close = not => notifications.update(n => n.filter(n => n !== not))

function closeClick(e, not) {
  e.stopPropagation();
  close(not)
}

function click(not) {
  if (!not.target) return;
  if (not.external) {
    window.open(not.target, "_blank");
  } else {
    navigate(not.target);
  }
  close(not)
}
</script>

<div class="notifications">
  {#each $notifications as not (not.id)}
    <div class="notification row mb-8" transition:fade on:click={() => click(not)}>
      <span class="material-icons mr-8">notifications</span>
      <div class="col f1">
        <div class="title mb-8">{not.title}</div>
        <div class="subtitle">Click here to join</div>
      </div>
      <span class="material-icons" on:click={e => closeClick(e, not)}>close</span>
    </div>
  {/each}
</div>

<style lang="scss">
@import './theme';
@import './util';

.notifications {
  position: fixed;
  top: 50px;
  right: 50px;
  z-index: 1000;

  @include landscape {
    left: 25px;
    right: 25px;
  }
}

.notification {
  font-family: $secondary-font;
  width: 556px;
  color: white;
  background-color: $primary-color;
  padding: 8px;
  cursor: pointer;

  @include landscape {
    width: unset;
  }
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.subtitle {
  font-size: 12px;
  font-weight: 300;
}
</style>